<template>
    <div class="dashboard__filters"
        :class="{'filters--general' : generalFilters}"
    >
        <div
            v-if="filter"
            class="current-filters"
            :class="{ 'justify-items-start': this.enableFastFilters }"
        >
            <div
                v-for="(filt, index) in activeFilters2"
                :key="index"
                class="filter"
                :filter-tooltip="tooltipFilter(filt)"
                :class="{ week: Object.keys(filt)[0].match(/week/g) }"
            >
                {{ currentFilterLabel(filt) }}
            </div>
        </div>

        <div class="filter-wrapper">
            <!-- Filtros rapidos -->
            <div v-show="this.enableFastFilters && filter.state === 'finished'" class="fast-filters">
                <FastFiltersGeneral
                    @FastFilterChanged="onFastFilterChanged"
                    ref="fastFilters"
                />
            </div>

            <div class="we-dropdown">
                <button
                    class="btn btn--with-icon btn--inverted we-dropdow-toggle btn-toggle-filters"
                    @click="showFilters = !showFilters"
                >
                    <vs-icon icon="filter_list" />
                    <span>Filtrar</span>
                </button>

                <div
                    class="we-dropdown-menu dropdown-menu--right"
                    :class="{ 'is-visible': showFilters }"
                >
                    <div class="hidden-desktop">
                        <button @click="closeFilters" class="close-filters">
                            <vs-icon icon="keyboard_backspace" />
                        </button>
                        <h2>Filtrar por</h2>
                    </div>

                    <template
                        v-if="
                            !['marketChart', 'entityChart', 'ranking'].includes(
                                String(filterFor)
                            )
                        "
                    >
                        <button v-if="(currentUser.canSell && ['', 'sell'].includes(globalType)) 
                            || dashboardTab === 'market'"
                            :class="{ active: filter.state == 'published' && filter.type == 'sell' }"
                            class="btn btn-state"
                            @click="changeFilter({state: 'published', type: 'sell'})"
                        >
                            <vs-icon icon="done"></vs-icon>
                            Ofrecido
                        </button>
                        <button
                            v-if="
                                (currentUser.canBuy &&
                                    ['', 'buy'].includes(globalType)) ||
                                dashboardTab === 'market'
                            "
                            :class="{
                                active:
                                    filter.state == 'published' &&
                                    filter.type == 'buy',
                            }"
                            class="btn btn-state"
                            @click="
                                changeFilter({
                                    state: 'published',
                                    type: 'buy',
                                })
                            "
                        >
                            <vs-icon icon="done"></vs-icon>
                            Demandado
                        </button>
                        <!-- cambiar state por semana de entrega -->
                        <button
                            :class="{ active: filter.state == 'finished' }"
                            class="btn btn-state"
                            @click="
                                changeFilter({
                                    state: 'finished',
                                    type: null,
                                })
                            "
                        >
                            <vs-icon icon="done"></vs-icon>
                            Concretado
                        </button>
                    </template>

                    <div>
                        <WeWeekPicker
                            :label="weekLabel + ' desde'"
                            v-model="filter.weekFrom"
                            :min-week="minWeek"
                            :canRemove="false"
                            ref="weekStartAtSelector"
                            @internalInputChanged="
                                onInternalInputChange($event, 'start')
                            "
                        />
                    </div>

                    <div>
                        <WeWeekPicker
                            :label="weekLabel + ' hasta'"
                            v-model="filter.weekTo"
                            :min-week="filter.weekFrom"
                            ref="weekEndAtSelector"
                            @input="inputChanged()"
                            @internalInputChanged="
                                onInternalInputChange($event, 'end')
                            "
                        />
                    </div>

                    <div v-if="['cards'].includes(String(filterFor))">
                        <div class="input-group">
                            <!--v-model="filters.weights"-->
                            <select
                                name="filters-weight"
                                :class="{ changed: weights }"
                                v-model="filter.weight"
                                @change="inputChanged()"
                            >
                                <option
                                    :key="index"
                                    :value="weight.value"
                                    :text="weight.name"
                                    v-for="(weight, index) in weights"
                                >
                                    {{ weight.name }}
                                </option>
                            </select>
                            <label for="filters-subtype">Kilos</label>
                        </div>
                    </div>

                    <div
                        v-if="['cards'].includes(String(filterFor))"
                        class="input-multiple-select"
                    >
                        <label for="filters-subtype">Categoría</label>
                        <multiselect
                            v-model="selectedCategories"
                            :options="categories"
                            :multiple="true"
                            :close-on-select="false"
                            :clear-on-select="false"
                            placeholder="Seleccione"
                            label="name"
                            track-by="name"
                            :show-labels="false"
                            :allowEmpty="false"
                        >
                            <template
                                slot="selection"
                                slot-scope="{ values, search, isOpen }"
                                ><span
                                    class="multiselect__single"
                                    v-if="filter.category.length && !isOpen"
                                    >{{ filter.category.length }}
                                    {{
                                        filter.category.length > 1
                                            ? "seleccionadas"
                                            : "seleccionada"
                                    }}</span
                                ></template
                            >
                        </multiselect>
                    </div>

                    <div class="filter-actions">
                        <button
                            @click="clearFilters"
                            class="btn btn-secondary btn-flat btn--full-width"
                        >
                            Limpiar filtros
                        </button>
                        <button
                            @click="closeFilters"
                            class="btn btn--full-width hidden-desktop"
                        >
                            Aplicar filtros
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState, mapMutations } from "vuex";
import WeWeekPicker from "@/lib/WebExperto/components/WeWeekPicker.vue";
import Multiselect from "vue-multiselect";
import FastFiltersGeneral from "./FastFiltersGeneral.vue";

export default {
    components: {
        WeWeekPicker,
        Multiselect,
        FastFiltersGeneral,
    },
    data() {
        return {
            globalType: "",
            currentWeek: "",
            currentYear: "",
            showFilters: false,
            weekLabel: "Semana",
            ready: false,
            internalStartWeekSelected: undefined,
            internalEndWeekSelected: undefined,
            categories: [
                {
                    name: "MEI",
                    value: "MEI (Macho Entero Inmunocastrado)",
                },
                { name: "Cerdas Descarte", value: "Cerdas Descarte" },
                { name: "Capones", value: "Capones" },
            ],
            filter: {
                type: null,
                state: "finished",
                weight: null,
                weekFrom: null,
                weekTo: null,
                category: ["MEI (Macho Entero Inmunocastrado)", "Capones"],
            },
            weights: [
                { name: "Todos", value: null },
                { name: "Menor a 109", value: "0, 109" },
                { name: "De 110 a 119", value: "110, 119" },
                { name: "De 120 a 129", value: "120, 129" },
                { name: "De 130 a 139", value: "130, 139" },
                { name: "Mayor a 140", value: "140, 100000" },
            ],
            selectedCategories: [
                {
                    name: "MEI",
                    value: "MEI (Macho Entero Inmunocastrado)",
                },
                { name: "Capones", value: "Capones" },
            ],
        };
    },
    props: {
        enableFastFilters: {
            type: Boolean,
            required: false,
            default: false,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        organizations: {
            type: Array,
            required: false,
            default: () => [],
        },
        dashboardTab: {
            type: String,
            required: false,
            default: "",
        },
        filterFor: {
            type: String,
            required: false,
        },
        generalFilters: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.onClickOutside);
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.User.currentUser,
        }),

        InternalStartAndEndWeekSelected() {
            return `${this.internalStartWeekSelected}|${this.internalEndWeekSelected}`;
        },
        actualTime() {
            if (this.currentUser) {
                return this.currentUser.currentTime;
            }
            return new Date().toISOString().split("T")[0];
        },
        activeFilters2() {
            var obj = [];
            Object.keys(this.filter).forEach((key) => {
                if (this.filter[key]) {
                    if (["state", "type"].includes(key)) {
                        return;
                    }
                    obj.push({ [key]: this.filter[key] });
                }
            });
            if (
                !["marketChart", "entityChart", "ranking"].includes(
                    String(this.filterFor)
                )
            ) {
                if (this.filter.state == "published") {
                    if (this.filter.type == "sell") {
                        obj.push({ state: "offered" });
                    } else {
                        obj.push({ state: "demanded" });
                    }
                } else {
                    obj.push({ state: "finished" });
                }
            }
            return obj;
        },
        invertedWeekFrom() {
            if (this.filter.weekFrom) {
                var WY = this.filter.weekFrom.split("-");
                return `${WY[1]}${WY[0]}`;
            }
        },
        invertedWeekTo() {
            if (this.filter.weekTo) {
                var WY = this.filter.weekTo.split("-");
                return `${WY[1]}${WY[0]}`;
            }
        },
        minWeek() {
            // en concretado/demandado, es decir, si el estado es published pickear fecha a partir de semana actual en adelante
            if (
                this.filter.state !== "finished" &&
                this.filterFor === "cards"
            ) {
                let dateSplit = "";
                if (this.actualTime) {
                    dateSplit = this.actualTime
                        .split(" ")[0]
                        .replace(/\//g, "-")
                        .split("-");
                } else {
                    dateSplit = new Date().toISOString().split("T")[0];
                }
                var date = new Date(
                    parseInt(dateSplit[0]),
                    parseInt(dateSplit[1]) - 1,
                    parseInt(dateSplit[2])
                );
                return this.getMinWeek(date);
            } else {
                return undefined;
            }
            // return this.getNWeeks(this.actualTime, -2)
        },
        maxWeek() {
            if (this.filter.state === "published") {
                return this.getNWeeks(this.actualTime, 1);
            }
            return [this.currentWeek, this.currentYear];
        },
    },
    created() {
        document.addEventListener("click", this.onClickOutside);
    },
    mounted() {
        this.getDate(this.actualTime);
        this.selectDefaultWeeks();
        this.setWeekLabel();
        this.setType();
        this.clearFilters();
        this.ready = true;
    },
    watch: {
        InternalStartAndEndWeekSelected(newVal, oldVal) {
            // NO SAQUEN el newVal y OldVal, sino no funciona.

            // Este metodo se utiliza solamente para detectar los cambios cuando se cambia la fecha a mano
            // Y en caso de que se seleccione una fecha igual a los filtros rapidos, lo aplico.
            if (this.filter.state != "finished") return;

            let start = this.filter.weekFrom;
            let end = this.filter.weekTo;

            // Esto es para ver si coinciden con las fechas preestablecidas para los filtros rapidos.
            if (
                this.areSameDateString(
                    start,
                    `${this.currentWeek - 1}-${this.currentYear}`
                )
            ) {
                let weekArray = this.getNWeeks(this.actualTime, 1);
                if (
                    weekArray &&
                    this.areSameDateString(
                        end,
                        `${weekArray[0]}-${weekArray[1]}`
                    )
                ) {
                    // hubo match para filtro: "now"
                    this.$refs.fastFilters.updateFilterSelection("now");
                }
            } else {
                let refDate = new Date(this.actualTime.substring(0, 18));
                let oneMonthAgo = new Date(
                    refDate.setMonth(refDate.getMonth() - 1)
                );

                refDate = new Date(this.actualTime.substring(0, 18));
                let threeMonthAgo = new Date(
                    refDate.setMonth(refDate.getMonth() - 3)
                );
                oneMonthAgo = this.getMinWeek(oneMonthAgo);
                threeMonthAgo = this.getMinWeek(threeMonthAgo);

                if (this.areSameDateString(start, oneMonthAgo)) {
                    let weekArray = this.getNWeeks(this.actualTime, 0);
                    if (
                        weekArray &&
                        this.areSameDateString(
                            end,
                            `${weekArray[0]}-${weekArray[1]}`
                        )
                    ) {
                        // Hay match para last month
                        this.$refs.fastFilters.updateFilterSelection(
                            "lastMonth"
                        );
                    }
                }
                if (this.areSameDateString(start, threeMonthAgo)) {
                    let weekArray = this.getNWeeks(this.actualTime, 0);
                    if (
                        weekArray &&
                        this.areSameDateString(
                            end,
                            `${weekArray[0]}-${weekArray[1]}`
                        )
                    ) {
                        // Hay match para last 3 month
                        this.$refs.fastFilters.updateFilterSelection(
                            "last3Months"
                        );
                    }
                }
                this.$refs.fastFilters.updateFilterSelection("noOne");
            }
        },
        currentUser() {
            this.setType();
            this.$emit("filter", this.filter);
        },
        "currentUser.currentTime"() {
            this.getDate(this.actualTime);
            this.selectDefaultWeeks();
            this.$emit("filter", this.filter);
        },
        "filter.weekFrom"() {
            if (this.filter.weekFrom && this.filter.weekTo) {
                let yearFrom = parseInt(this.filter.weekFrom.split("-")[1]);
                let yearTo = parseInt(this.filter.weekTo.split("-")[1]);
                let weekFrom = parseInt(this.filter.weekFrom.split("-")[0]);
                let weekTo = parseInt(this.filter.weekTo.split("-")[0]);
                if (!(yearFrom < yearTo)) {
                    if (yearFrom > yearTo) {
                        this.setWeekTo();
                    } else if (weekFrom >= weekTo) {
                        this.setWeekTo();
                    } else {
                        this.inputChanged();
                    }
                } else {
                    this.inputChanged();
                }
            }
        },

        selectedCategories() {
            if (this.selectedCategories) {
                this.filter.category = this.selectedCategories.map(
                    (cat) => cat.value
                );
            } else {
                this.filter.category = null;
            }
            this.inputChanged();
        },
    },
    methods: {
        onFastFilterChanged(filterOption) {
            /*
                - Este método se ejecuta cuando se cambia el filtro rapido.
                - Setea las fechas correspondientes segun el boton que se toque.
                - A su vez, cuando se cambia la fecha manualmente se desactivan los filtros rapidos.
            */

            // El substring está hecho porque navegadores viejos lo necesitan para funcionar correctamente.
            // El replace está hecho para que funcione en safari tambien.

            let refDate = new Date(this.actualTime.substring(0, 18).replace(/-/g, "/"));
            let StartweekAndYear;
            let endWeek = this.getNWeeks(this.actualTime, 1);
            switch (filterOption) {
                case "now":
                    StartweekAndYear = `${ this.currentWeek }-${ this.currentYear }`;
                    break;
                case "lastMonth":
                    let oneMonthAgo = new Date(refDate.setMonth(refDate.getMonth() - 1));
                    StartweekAndYear = this.getMinWeek(oneMonthAgo);
                    if (endWeek[0] == 1) {
                        endWeek[0] = 52;
                        endWeek[1] -= 1;
                    } else {
                        endWeek[0] -= 1;
                    }
                    break;
                case "last3Months":
                    let threeMonthAgo = new Date(refDate.setMonth(refDate.getMonth() - 3));
                    StartweekAndYear = this.getMinWeek(threeMonthAgo);
                    if (endWeek[0] == 1) {
                        endWeek[0] = 52;
                        endWeek[1] -= 1;
                    } else {
                        endWeek[0] -= 1;
                    }
                    break;
            }
            let startWeek = StartweekAndYear.split("-")[0];
            let startYear = StartweekAndYear.split("-")[1];

            // seteo la fecha minima.
            this.$refs.weekStartAtSelector.selectWeek(
                startWeek,
                startYear,
                true
            );
            // seteo la fecha maxima
            this.$refs.weekEndAtSelector.selectWeek(endWeek[0], endWeek[1]);
        },
        onInternalInputChange(weekSelected, changedSelector) {
            if (changedSelector === "start") {
                this.internalStartWeekSelected = weekSelected;
            }
            if (changedSelector === "end") {
                this.internalEndWeekSelected = weekSelected;
            }
        },
        finishedTypeFilter() {
            if (this.dashboardTab === "market") {
                return null;
            } else {
                return this.filter.type;
            }
        },
        areSameDateString(date1, date2) {
            if (date1 === date2) {
                return true;
            }

            let trimDate1 = date1;
            let trimDate2 = date2;

            if (date1[0] === "0") {
                trimDate1 = date1.substring(1);
            }
            if (date2[0] === "0") {
                trimDate2 = date2.substring(1);
            }
            return trimDate1 === trimDate2;
        },
        getMinWeek(date) {
            var d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 12));
            d.setUTCDate(d.getUTCDate() + 7 - d.getUTCDay());
            var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
            return `${weekNo}-${d.getFullYear()}`;
        },
        setWeekTo() {
            var date = this.$refs.weekEndAtSelector
                .getDateOfWeek(
                    this.filter.weekFrom.split("-")[0],
                    this.filter.weekFrom.split("-")[1]
                )
                .toLocaleString();
            let newWeekTo = this.getNWeeks(date, 2);
            //this.filter.weekTo = `${newWeekTo[0]}-${newWeekTo[1]}`
            this.$refs.weekEndAtSelector.selectWeek(newWeekTo[0], newWeekTo[1]);
            this.inputChanged();
        },
        currentFilterLabel(filt) {
            var firstKey = Object.keys(filt)[0];
            if (firstKey === "weekFrom") {
                return `${this.weekLabel} desde: ${filt[firstKey]}`;
            }
            if (firstKey === "weekTo") {
                return `${this.weekLabel} hasta: ${filt[firstKey]}`;
            }
            if (firstKey === "category") {
                return `${this.$t(`filter.${firstKey}`)}: ${filt[firstKey]}`.replace("(Macho Entero Inmunocastrado)",'');
            }
            return `${this.$t(`filter.${firstKey}`)}: ${
                /[0-9]/.test(filt[firstKey])
                    ? filt[firstKey]
                    : this.$t(`filter.${filt[firstKey]}`)
            }`;
        },
        tooltipFilter(filt) {
            var firstKey = Object.keys(filt)[0];
            if (firstKey === "weekFrom") {
                return this.$refs.weekStartAtSelector.dateRange;
            } else if (firstKey === "weekTo") {
                return this.$refs.weekEndAtSelector.dateRange;
            }
        },
        selectDefaultWeeks() {
            switch (this.filterFor) {
                case "cards":
                    // Las semanas por defecto (siempre 3) en este caso serán:
                    // Para el filtro concretado: Anterior, Actual y siguente.
                    // Ofrecido o Demandado: currentWeekActual y las proximas dos.
                    let weeksToShift = 0;

                    if (this.filter.state === "finished") {
                    } else {
                        weeksToShift = 1;
                    }

                    if(this.currentWeek == 1) {
                      this.currentWeek = 0;
                    }

                    if (this.currentWeek == 0) {
                      this.currentWeek = 52
                    }

                    if (this.currentWeek + weeksToShift > 52) {
                        this.currentWeek = weeksToShift;
                        this.currentYear += 1;
                    }

                    this.$refs.weekStartAtSelector.selectWeek(
                        this.currentWeek + weeksToShift,
                        this.currentYear,
                        true
                    );

                    var endWeek = this.getNWeeks(this.actualTime, 1);
                    this.$refs.weekEndAtSelector.selectWeek(
                        endWeek[0] + weeksToShift,
                        endWeek[1]
                    );
                    break;
                case "entityChart":
                    var startWeek = this.getNWeeks(this.actualTime, -4);
                    var endWeek = this.getNWeeks(this.actualTime, 4);
                    this.$refs.weekStartAtSelector.selectWeek(
                        startWeek[0],
                        startWeek[1]
                    );
                    this.$refs.weekEndAtSelector.selectWeek(
                        endWeek[0],
                        endWeek[1]
                    );
                    break;
                case "ranking":
                    var startWeek = this.getNWeeks(this.actualTime, -4);
                    this.$refs.weekStartAtSelector.selectWeek(
                        startWeek[0],
                        startWeek[1]
                    );
                    this.$refs.weekEndAtSelector.selectWeek(
                        this.currentWeek,
                        this.currentYear
                    );
                    break;
                case "marketChart":
                    this.$refs.weekStartAtSelector.selectWeek(
                        this.currentWeek,
                        this.currentYear
                    );
                    this.$refs.weekEndAtSelector.selectWeek(
                        this.currentWeek + 1,
                        this.currentYear
                    );
                    break;
                default:
                    this.$refs.weekStartAtSelector.selectWeek(
                        this.currentWeek,
                        this.currentYear
                    );
                    break;
            }
        },
        setType() {
            if (this.currentUser.canSell && this.currentUser.canBuy) {
                this.globalType = "buy";
                this.filter.type = "buy"
            }

            this.$emit("globalType", this.globalType);


            if(this.dashboardTab == "entity" && this.filterFor == "entityChart"){

                if(this.currentUser.canSell && this.currentUser.canBuy){
                    // por defecto se abre la ventana de compra.
                    this.filter.type = "buy"
                }
                if(this.currentUser.canSell && !this.currentUser.canBuy){
                    this.filter.type = "sell"
                }
                if(!this.currentUser.canSell && this.currentUser.canBuy){
                    this.filter.type = "buy"
                }

                this.$emit("initialTypeSetted")
                return
            }


            if (this.currentUser.canSell || this.currentUser.canBuy) {
                if (
                    this.dashboardTab === "market" &&
                    this.filterFor === "cards"
                ) {
                    return this.currentUser.canBuy
                        ? (this.filter.type = "sell")
                        : (this.filter.type = "buy");
                } else if (this.dashboardTab === "entity") {
                    if (
                        (this.filterFor === "entityChart" &&
                            this.currentUser.canSell &&
                            this.currentUser.canBuy) ||
                        this.filterFor === "cards"
                    ) {
                        return this.currentUser.canBuy
                            ? (this.filter.type = "buy")
                            : (this.filter.type = "sell");
                    }
                }
            }
        },
        changeFilter({ state, type }) {
            this.changeType(type);
            this.changeState(state);
            this.inputChanged();
        },
        changeState(state) {
            // Solo cambia las fechas si el state (published, finished) cambió, sino no.
            if (this.filter.state != state) {
                this.filter.state = state;
                this.selectDefaultWeeks();
                this.setWeekLabel();
            }
        },
        changeType(type) {
            this.filter.type = type;
        },
        setWeekLabel() {
            if (this.filterFor === "cards") {
                this.weekLabel = "Semana de entrega";
            } else if (this.filterFor === "marketChart") {
                this.weekLabel = "Semana concretado";
            } else if (this.filterFor === "ranking") {
                this.weekLabel = "Semana de finalización";
            } else if (this.filterFor === "entityChart") {
                this.weekLabel = "Semana de entrega";
            }
        },
        inputChanged() {
            if (this.ready) {
                this.$emit("filter");
            }
        },
        clearFilters() {
            this.filter = {
                type: null,
                state: "finished",
                weight: null,
                weekFrom: null,
                weekTo: null,
                category: [
                    {
                        name: "MEI",
                        value: "MEI (Macho Entero Inmunocastrado)",
                    },
                    { name: "Capones", value: "Capones" },
                ],
            };
            this.selectedCategories = this.filter.category;
            this.$refs.weekEndAtSelector.clearWeek();
            this.selectDefaultWeeks();
            this.$emit("search");
        },
        closeFilters() {
            this.showFilters = false;
        },
        onClickOutside(ev) {
            try {
                if (
                    this.categories
                        .map((cat) => cat.name)
                        .includes(ev.toElement.innerText)
                ) {
                    return;
                }
                if (this.$refs.multipleSelect) {
                    if (
                        !this.$el.contains(ev.target) &&
                        this.$refs.multipleSelect.active
                    ) {
                        this.$refs.multipleSelect.active = false;
                        return;
                    }
                }
                if (!this.$el.contains(ev.target) && ev.target.id !== 'toggleFilters') {
                    this.closeFilters();
                }
            } catch (error) {
                if (!this.$el.contains(ev.target)) {
                    this.closeFilters();
                }
            }
        },
        // Move to /utils
        getDate(date) {
            if (date !== undefined) {
                if (!date) {
                    date = new Date().toLocaleString();
                }
                date = date.split(" ")[0];
                const dateSplit = /\//.test(date)
                    ? date.replace(/\//g, "-").split("-").reverse().join("-")
                    : date.split("-");
                var date = new Date(
                    parseInt(dateSplit[0]),
                    parseInt(dateSplit[1]) - 1,
                    parseInt(dateSplit[2])
                );
                var d = new Date(
                    Date.UTC(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate()
                    )
                );
                d.setUTCDate(d.getUTCDate() + 7 - d.getUTCDay());
                var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
                var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
                this.currentWeek = weekNo - 1;
                this.currentYear = d.getFullYear();
            }
        },
        getNWeeks(incomingDate, n = 0) {
            // Te da la semana de una fecha en especifico. El segundo parametro sirve para mover n semanas en adelante.
            if (!incomingDate) {
                incomingDate = new Date().toLocaleString();
            }
            let date = incomingDate.split(" ")[0];
            // /\//.test() <-- looks for '/' in the date
            const dateSplit = /\//.test(date) ? date.replace(/\//g, "-").split("-").reverse() : date.split("-");

            date = new Date(
                parseInt(dateSplit[0]),
                parseInt(dateSplit[1]) - 1,
                parseInt(dateSplit[2])
            );
            var d = new Date(
                Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
            );
            d.setUTCDate(d.getUTCDate() + 7 - d.getUTCDay() + 7 * n);
            var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
            var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
            return [weekNo, d.getFullYear()];
        },
    },
};
</script>
